module.exports = __webpack_public_path__ + "assets/img/ele.bac9e7eb.png";